import { z } from "zod";
// Unambiguous alphabet: no 0/O, 1/I/L, 2/Z, 5/S, 8/B.
export const INVITATION_PAIRING_CODE_ALPHABET = "ACDEFGHJKMNPQRTUVWXY34679";
export const INVITATION_PAIRING_CODE_LENGTH = 6;
const CODE_PATTERN = new RegExp(`^[${INVITATION_PAIRING_CODE_ALPHABET}]{${INVITATION_PAIRING_CODE_LENGTH}}$`);
/** Strips whitespace and `-`, upper-cases, then requires exactly 6 alphabet characters. */
export const invitationPairingCodeSchema = z
    .string()
    .transform(value => value.replace(/[\s-]/g, "").toUpperCase())
    .pipe(z.string().regex(CODE_PATTERN));
/** "K7P4QX" -> "K7P-4QX" */
export const formatInvitationPairingCode = (code) => `${code.slice(0, 3)}-${code.slice(3)}`;
/**
 * Pure generator; the random source is injected (`randomInt(max)` returns an
 * integer in [0, max)) so this module stays free of node `crypto`.
 */
export const generateInvitationPairingCode = (randomInt) => {
    let code = "";
    for (let i = 0; i < INVITATION_PAIRING_CODE_LENGTH; i++) {
        code += INVITATION_PAIRING_CODE_ALPHABET.charAt(randomInt(INVITATION_PAIRING_CODE_ALPHABET.length));
    }
    return code;
};
//# sourceMappingURL=invitationPairingCode.js.map